(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["s2-cookie-preferences-link"] && !Shopify.designMode) return;
  try {
    (function () {
    function links() {
      return document.querySelectorAll('.s2-cookie-prefs-link');
    }
    function reveal() {
      if (!window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return false;
      links().forEach(function (link) { link.hidden = false; });
      return true;
    }
    document.addEventListener('click', function (event) {
      var link = event.target.closest('.s2-cookie-prefs-link');
      if (link && window.privacyBanner) window.privacyBanner.showPreferences();
    });
    // Shopify loads the banner script asynchronously; check on load and once more shortly after.
    window.addEventListener('load', function () {
      if (!reveal()) setTimeout(reveal, 3000);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["s2-localization-picker"] && !Shopify.designMode) return;
  try {
    // Submit the country form as soon as a country is chosen (the language buttons submit themselves).
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (select.matches && select.matches('[data-s2loc-country]') && select.form) select.form.submit();
  });
  } catch(e) { console.error(e); }
})();

})();
